import { AddMustReport } from "app/screens/residents/show/AddMustReport";

export default function AddMustReportPage() {
  return <AddMustReport />;
}
